import { useEffect, useState } from 'react'

import {
  PaymentOption,
  type Link,
} from '@/modules/checkout/_core/domain/entities'
import { useFeatureFlag } from '@/shared/hooks/use-feature-flag'
import { FeatureFlag } from '@/shared/libs/launchdarkly/constants'

export const useIsAutomaticPixEnabled = (id: string, link?: Link) => {
  const { isReady, variation, identify } = useFeatureFlag()
  const [isIdentified, setIsIdentified] = useState(false)

  const isEligible =
    Boolean(id) &&
    Boolean(
      link?.paymentTypes.some(
        (method) => method.type === PaymentOption.AutomaticPixCopyPaste,
      ),
    )

  useEffect(() => {
    if (!isReady || !isEligible) {
      return
    }

    let isSubscribed = true

    const release = () => {
      if (isSubscribed) {
        setIsIdentified(true)
      }
    }

    identify({
      linkId: id,
      companyDocument: link?.company.document,
      mainSeller: link?.mainSeller,
    }).then(release, release)

    return () => {
      isSubscribed = false
    }
  }, [
    id,
    identify,
    isEligible,
    isReady,
    link?.company.document,
    link?.mainSeller,
  ])

  return isIdentified && variation(FeatureFlag.PixAutomatic, false)
}
